module.exports = __webpack_public_path__ + "static/img/tongguo.9d8f69ed.png";